import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PatientState } from './patients.reducer';

export const selectDataState = createFeatureSelector<PatientState>('data');

export const patientSelector = createSelector(selectDataState, (state) => state.patient);
export const patientNavigationSelector = createSelector(selectDataState, (state) => state.isDisabledPatientNavigation);
export const hideNavigationSelector = createSelector(selectDataState, (state) => state.hidePatientNavigation);
